module.exports = __webpack_public_path__ + "static/media/logo_light.21f06cc5.png";